import { Bars, Nav, NavIcon, Navlink } from "./NavBarElement"

const Navbar = ( { toggle } ) => {
    return (
        <>
            <Nav>
                <Navlink to='/'>Quán bún đậu 16</Navlink>
                <NavIcon onClick={toggle}>
                    <p>menus</p>
                    <Bars/>
                </NavIcon>
            </Nav>
        </>
    )
}

export default Navbar
